// Feature-flag helpers — read import.meta.env at call time so vi.stubEnv()
// during tests flips the value without bouncing the module. A flag is on for
// case-insensitive 'true' / '1' / 'yes' / 'on'; anything else is false.

const TRUTHY = new Set(["true", "1", "yes", "on"]);

function readFlag(name: keyof ImportMetaEnv): boolean {
  const raw = import.meta.env[name];
  if (!raw || typeof raw !== "string") return false;
  return TRUTHY.has(raw.toLowerCase());
}

/** Dev-only brand fixture page gating — enables the /dev/brand showcase
 *  route. Set VITE_DEV_BRAND_FIXTURES=true in a local .env only;
 *  the flag should never be set in deployed environments. */
export function isDevBrandFixturesEnabled(): boolean {
  return readFlag("VITE_DEV_BRAND_FIXTURES");
}
